import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 32, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "115%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Chapter({ kicker, title, subtitle, testId }) {
  return (
    <Reveal className="mb-12 md:mb-16">
      <p className="font-body text-xs md:text-sm tracking-[0.35em] uppercase text-[#C9A227] mb-4" data-testid={testId ? `${testId}-kicker` : undefined}>
        {kicker}
      </p>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#F5F7FA] leading-tight" data-testid={testId ? `${testId}-title` : undefined}>
        {title}
      </h2>
      {subtitle && <p className="mt-4 max-w-2xl text-base md:text-lg text-[#EDF1F6]">{subtitle}</p>}
      <div className="mt-6 h-px w-24 bg-gradient-to-r from-[#C9A227] to-transparent" />
    </Reveal>
  );
}
